<template>
     <b-card
        v-if="user.person.position"
        class="mt-2"
    >
        <template #header>
            <h6 class="card-subtitle">
                <font-awesome-icon icon="link"></font-awesome-icon>
                Links
            </h6>
        </template>
        <b-card-body class="text-center">
            <router-link
                :to="{ name: 'membership' }"
                class="btn btn-outline-primary"
            >
                <font-awesome-icon icon="link" class="mr-2" /> View Membership
            </router-link>
        </b-card-body>
    </b-card>
</template>
<script>
import { mapState } from 'vuex'
export default {
    computed: mapState(["user"])
}
</script>